import { useCallback } from 'react'
import { useMutation } from '@apollo/client/react'
import { AdminAPI, GraphQL } from '@guestgoodie/graphql'

import { useAddRecentlyRead } from './useOrdersSubscriptions'

export function useMarkAsRead(item: GraphQL.OrderFragmentFragment) {
  const [markRead, { loading }] = useMutation(AdminAPI.order.MARK_AS_READ)
  const addRecentlyRead = useAddRecentlyRead()

  const markAsRead = useCallback(() => {
    addRecentlyRead(item.id)

    markRead({
      variables: {
        id: item.id
      }
    })
  }, [item, markRead, addRecentlyRead])

  return {
    markAsRead,
    loading
  }
}
